<div class="quadro">
  <nav class="menu">
    <button class="menu-item" [class.active]="opcaoSelecionada === 'sobre-vaga'"
      (click)="selecionarOpcao('sobre-vaga')">
      Sobre a vaga
      <i *ngIf="formInvalido && !view" title="Por favor, preencha todos os campos obrigatórios." class="fas fa-exclamation-triangle ml-2"></i>
    </button>
    <button class="menu-item" [class.active]="opcaoSelecionada === 'sobre-candidato'"
      (click)="selecionarOpcao('sobre-candidato')">
      Sobre o Candidato
    </button>
    <button class="menu-item" [class.active]="opcaoSelecionada === 'publicacao-vaga'"
      (click)="selecionarOpcao('publicacao-vaga')">
      Publicação da vaga
      <i *ngIf="!vaga?.dataInicio && !view" title="Por favor, preencha todos os campos obrigatórios." class="fas fa-exclamation-triangle ml-2"></i>
    </button>
  </nav>
  <div class="conteudo">
    <form-sobre-vaga (change)="invalidForm()" [empresaEspecial]="empresaEspecial" [view]="view" [vaga]="vaga" [hidden]="opcaoSelecionada !== 'sobre-vaga'"></form-sobre-vaga>
    <form-sobre-candidato [empresaEspecial]="empresaEspecial" [view]="view" [vaga]="vaga" [hidden]="opcaoSelecionada !== 'sobre-candidato'"></form-sobre-candidato>
    <form-publicacao-vaga [edit]="edit"  [view]="view" [vaga]="vaga" [hidden]="opcaoSelecionada !== 'publicacao-vaga'"></form-publicacao-vaga>
  </div>
</div>

<div *ngIf="!view" class="botoes-container">
  <span class="salvar-rascunho" [class.disabled]="view" (click)="save(true)">Salvar rascunho</span>
  <button type="submit" class="btn btn-green" [disabled]="saving || view" (click)="save(false)">
    {{ labelSave }}
  </button>
</div>
